var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPathCrossCountrySkiing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 -361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,361.01c12.15,0,21.99,9.85,21.99,21.99S48.15,404.99,36,404.99S14.01,395.15,14.01,383 c0,0,0,0,0,0C14.01,370.85,23.85,361.01,36,361.01z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.359 364.915)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.78,2.82l-0.7,0.11L6.96,4.68L7.9,6.34H0.2v0.53h7.83l-0.55,1.7L4.52,9.53l-0.01,1.42 L0.25,9.51l-0.24,0.72l8.91,3l0.64-0.58l-4.98-1.68l4.39-1.29l2.05-4.34l0.67,0.54l2.99-0.63l-1.38,6.6l-1.32-2.98l-1.12-1.74 L9.94,9.18l0.75,0.54l1.27,2.84h-1.46l-0.73,0.76l8.44,0.01l0.82-0.77l0,0l-5.4-0.01l1.74-8.35l-0.49,0.04l0,0l-2.68,0.35 l-1.65-1.93L9.78,2.82z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    className: "st1",
    d: "M11.86,2.61c0.71,0.08,1.36-0.43,1.44-1.14s-0.43-1.36-1.14-1.44         c-0.71-0.08-1.35,0.43-1.44,1.14C10.64,1.87,11.14,2.52,11.86,2.61C11.86,2.61,11.86,2.61,11.86,2.61"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathCrossCountrySkiing);
export default __webpack_public_path__ + "static/media/path-cross-country-skiing.242fa21f.svg";
export { ForwardRef as ReactComponent };